import { t } from "i18next";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined"; // msg
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined"; // operator
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined"; // user
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined"; // change status
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined'; // service request
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined"; // news
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined"; // reject doc
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined'; // type notifica non registrata
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import { ROLE } from "./utils/constants/profiles";

export const typeNotificationIcon = (type, role) => {
    switch (type) {
        case "NEW_CHAT_MESSAGE":
        case 0:
            return { icon: <MailOutlineOutlinedIcon className="text-green-500" />, label: t("NewMessage"), route: t("chat") }; // tutti i ruoli
        case "NEW_USER_ASSOCIATED_TO_STUDIO":
        case 7:
            return { icon: <AccountCircleOutlinedIcon className="text-blue-500" />, label: t("NewUserStudio"), route: t("manageUsers") }; // solo admin
        case "NEW_USER_ASSOCIATED_TO_OPERATOR":
        case 1:
            if (role !== ROLE.USER) return { icon: <WorkOutlineOutlinedIcon className="text-blue-800" />, label: t("NewUserOperatore"), route: t("manageUsers") }; // admin e operator
            if (role === ROLE.USER) return { icon: <WorkOutlineOutlinedIcon className="text-blue-800" />, label: t("NewUserOperatoreUser"), route: t("profile") }; // user
            break;
        case "NEW_PRACTICE_STATUS":
        case 4:
            return { icon: <ChangeCircleOutlinedIcon className="text-yellow-500" />, label: t("NewStatusPractice"), route: t("managePractices") }; // solo user
        case "NEW_SERVICE_REQUEST":
        case 5:
            return { icon: <UpdateOutlinedIcon className="text-fuchsia-500" />, label: t("NewServiceRequest"), route: t("managePractices") }; // solo admin
        case "NEWS":
        case 3:
            return { icon: <NewspaperOutlinedIcon className="text-zinc-500" />, label: t("NewNews"), route: t("manage-news") }; // user
        case "DOCUMENT_REJECTED":
        case 2:
            return { icon: <HighlightOffOutlinedIcon className="text-danger" />, label: t("DocumentDiscarded"), route: t("documentManagement") }; // user
        case "NEW_SCHEDULE":
        case 6:
            return { icon: <EventOutlinedIcon className="text-red-400" />, label: t("NewSchedule"), route: t("documentManagement") }; // user
        default:
            return { icon: <RemoveCircleOutlineOutlinedIcon className="text-red-600 " />, label: "Notifica non registrata" };
    }
};


export const typeNotificationIconUser = (type) => {
    switch (type) {
        case 0:
            return { icon: <DocumentScannerOutlinedIcon className="text-blue-500" />, label: t("DocumentProcessed"), route: t("documentManagement") };
        case 1:
            return { icon: <SyncAltOutlinedIcon className="text-zinc-700" />, label: t("RegulationsUpdated"), route: "" };
        case 2:
            return { icon: <WorkHistoryOutlinedIcon className="text-blue-800" />, label: t("TaxDeadline"), route: "" };
        case 3:
            return { icon: <EventOutlinedIcon className="text-red-400" />, label: t("YearDeadlines"), route: "" };
        case 4:
            return { icon: <ChangeCircleOutlinedIcon className="text-yellow-500" />, label: t("NewStatusPractice"), route: t("managePractices") };
        case 5:
            return { icon: <MailOutlineOutlinedIcon className="text-green-700" />, label: t("NewPracticeMessage"), route: t("chat") };
        case 6:
            return { icon: <NoteAddOutlinedIcon className="text-fuchsia-500" />, label: t("NewPracticeDocument"), route: t("managePractices") };
        case 7:
            return { icon: <MailOutlineOutlinedIcon className="text-green-500" />, label: t("NewMessage"), route: t("chat") };
        case 8:
            return { icon: <NewspaperOutlinedIcon className="text-zinc-500" />, label: t("NewNews"), route: t("news") };

        default:
            return { icon: <RemoveCircleOutlineOutlinedIcon className="text-red-600 " />, label: "Notifica non registrata" };
    }
};


